import format from 'date-fns/format'
// import parse from 'date-fns/parse'
// const { format: formatDate } = require('date-fns');

export const getUTCDate = (dateString = Date.now(), min, max) => {
  const date = new Date(dateString);
  // 1529013600000 # bern
  // 1529029800000 # st johns
  const dateUtc = new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    // max ? date.getUTCDate() + 1 : date.getUTCDate(),
    max ? date.getDate() + 1 : date.getDate(),
    (min || max) ? 0 : date.getUTCHours(),
    (min || max) ? 0 : date.getUTCMinutes(),
    (min || max) ? 0 : date.getUTCSeconds(),
    (min || max) ? 0 : date.getUTCMilliseconds(),
  )

  return dateUtc
}

export const getDateFromTimeIso = timeIso => {
  const date = getUTCDate(timeIso)
  return format(date, 'YYYY-MM-dd')
}

export const getMinMaxDateFromTimeIso = ({ timeIso, min, max }) => {
  if (timeIso === '') {
    return null
  }
  try {
    const date = getUTCDate(timeIso, min, max)

    return date.toISOString()
  } catch(error) {
    console.log(timeIso)
    console.warn(error)

    return null
  }
}

export default getDateFromTimeIso



// WEBPACK FOOTER //
// ./src/utility/getDateFromTimeIso.js